import React from "react";

export function ApprovedCredits() {
  return (
    <section className="bg-sunny-top-left">
      <div className="container">
        <div className="row">
          <div id="certifications">
            <div className="col">
              <div className="row align-items-center">
                <div className="col-lg-5 col-md-4 order-md-2 text-center mb-5 mb-md-0">
                  <div className="d-flex justify-content-center align-items-center gap-3">
                    <img
                      className="img-fluid"
                      src="/img/logo-hrci.webp"
                      alt="HRCI certification"
                      style={{ maxWidth: "140px" }}
                    />
                    <img
                      className="img-fluid"
                      src="/img/logo-shrm.webp"
                      alt="SHRM certification"
                      style={{ maxWidth: "140px" }}
                    />
                  </div>
                </div>
                <div className="col-lg-7 col-md-8 order-md-1 text-center text-md-start">
                  <div style={{ maxWidth: "45em", display: "inline-block" }}>
                    <h1 className="color-white mb-0">
                      <span className="white-highlight">FinComp '27</span> is
                      proudly approved by SHRM{" "}
                      <span className="nobr">and HRCI</span>
                    </h1>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
